
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function Philosophy() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              私たちの理念
            </h2>
            <div className="mb-8">
              <h3 className="text-2xl font-semibold text-blue-600 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                Reason To Believe
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                私たちは「信頼される理由」を常に追求し続けます。お客様、グループ、パートナーの三方が良い関係を築き、
                持続可能な価値創造を実現することが私たちの使命です。
              </p>
            </div>

            <div className="space-y-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="bg-blue-100 p-4 rounded-lg flex-shrink-0">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-hand-heart-line text-blue-600 text-2xl"></i>
                  </div>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">お客様第一</h4>
                  <p className="text-gray-600">お客様の課題に真摯に向き合い、最適なソリューションを提供します。</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-green-100 p-4 rounded-lg flex-shrink-0">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-team-line text-green-600 text-2xl"></i>
                  </div>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">チームワーク</h4>
                  <p className="text-gray-600">グループ一丸となって、高品質なサービスを提供します。</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="bg-purple-100 p-4 rounded-lg flex-shrink-0">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-phone-fill text-purple-600 text-2xl"></i>
                  </div>
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">パートナーシップ</h4>
                  <p className="text-gray-600">パートナーとの信頼関係を大切に、共に成長していきます。</p>
                </div>
              </div>
            </div>

            <Link to="/vision">
              <Button variant="outline" size="lg">
                理念・ビジョンを詳しく見る
                <div className="w-5 h-5 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Button>
            </Link>
          </div>

          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/a106c164b1cd9064ddc9bc406a739a75/ab82e56affc3632b7b4f6221b96fd104.png"
              alt="私たちの理念"
              className="w-full rounded-xl shadow-lg object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/20 to-transparent rounded-xl"></div>
          </div>

        </div>
      </div>
    </section>
  );
}
